var _defs, _path, _g, _g2, _path2, _path3, _line, _line2, _path4, _path5, _path6, _path7, _path8, _path9, _line3, _line4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _line5, _line6, _path31, _line7, _line8, _line9, _path32, _path33, _path34, _path35, _path36, _path37, _polygon, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _circle, _circle2, _polyline, _path45, _path46, _path47, _rect, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _line10, _line11, _line12, _path56, _line13, _line14, _line15, _line16, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g3, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _ellipse, _circle3, _path114, _line17, _path115, _path116, _path117, _path118, _path119, _path120, _path121;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscribe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12,.cls-13,.cls-15,.cls-17,.cls-19,.cls-22,.cls-4,.cls-6{fill:none;}.cls-2{fill:#eaf9f3;}.cls-3{clip-path:url(#clip-path);}.cls-4,.cls-6{stroke:#b8d8c7;}.cls-12,.cls-13,.cls-15,.cls-17,.cls-19,.cls-22,.cls-4,.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-12,.cls-13,.cls-15,.cls-17,.cls-19,.cls-4{stroke-width:1.8px;}.cls-5{fill:#b8d8c7;}.cls-6{stroke-width:1.8px;}.cls-7{fill:#b0d7c0;}.cls-8{fill:#6dafa7;}.cls-9{fill:#ffe779;}.cls-10{fill:#22272e;}.cls-11{fill:#63737a;}.cls-12{stroke:#63737a;}.cls-13{stroke:#ffe779;}.cls-14{fill:#f4c2c9;}.cls-15{stroke:#e26e85;}.cls-16{fill:#fff;}.cls-17{stroke:#6dafa7;}.cls-18{fill:#f8ab5d;}.cls-19,.cls-22{stroke:#22272e;}.cls-20{clip-path:url(#clip-path-3);}.cls-21{fill:#e26e85;}.cls-22{stroke-width:1.8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M766.3,602l-520-14.9a48.07,48.07,0,0,1-46.5-43.3l-25.1-248a48.18,48.18,0,0,1,47.2-53l578.8-8a48.21,48.21,0,0,1,48.5,54.1L815.5,559.8A48.27,48.27,0,0,1,766.3,602Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495,351.5s-21.6,1.2-34.2,5.7-10.3,14.5-11.9,25-11.9,21.2-6.7,35.5,10.3,22.4,7.6,33.4-5.2,16.5-4.8,19.6,14.8,12.6,20.3,14.5,16.2-5.7,16.2-5.7,5.5,7.2,13.5,8.8,40.4-6.7,47.8-15a51.86,51.86,0,0,1-5-20.5c-.2-11.2,6.3-25.1,8.7-32.8s15.9-37.4,10.6-47.3C553.3,365.6,524.9,349.6,495,351.5Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M766.3,602l-520-14.9a48.07,48.07,0,0,1-46.5-43.3l-25.1-248a48.18,48.18,0,0,1,47.2-53l578.8-8a48.21,48.21,0,0,1,48.5,54.1L815.5,559.8A48.27,48.27,0,0,1,766.3,602Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.9,647H-73.6a15,15,0,0,1-15-15V396.3a15,15,0,0,1,15-15H341.9a15,15,0,0,1,15,15V632A15,15,0,0,1,341.9,647Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M891,631.2H471.9a15,15,0,0,1-15-15V271.9a15,15,0,0,1,15-15H891a15,15,0,0,1,15,15V616.2A15,15,0,0,1,891,631.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.3,311H152.4v-8.9h89.9a1.79,1.79,0,0,1,1.8,1.8v5.2A1.82,1.82,0,0,1,242.3,311Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226,302.1H205.7a4.32,4.32,0,0,1-4.3-3.8l-1.6-14.4a4.33,4.33,0,0,1,4.3-4.8h23.5a4.34,4.34,0,0,1,4.3,4.8l-1.6,14.4A4.41,4.41,0,0,1,226,302.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.4,279.1s-8-.8-9.6-11.6c0,0,7.2,2.1,9.5,7.2,0,0,1-11.4,6.4-12.5,0,0,2.4,8.5-1.4,12.7,0,0,2.9-4.8,10.3-4.7a13.6,13.6,0,0,1-9.2,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M338.7,431.1H248.5a4.23,4.23,0,0,1-4.2-4.2V399.5a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.1,4.1,0,0,1,338.7,431.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304,404.9H283.2a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5H304a1.54,1.54,0,0,1,1.5,1.5h0A1.54,1.54,0,0,1,304,404.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M338.7,476.9H248.5a4.23,4.23,0,0,1-4.2-4.2V445.3a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.1,4.1,0,0,1,338.7,476.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304,450.7H283.2a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5H304a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,304,450.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M801.9,509.2H711.7a4.23,4.23,0,0,1-4.2-4.2V477.6a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2V505A4.1,4.1,0,0,1,801.9,509.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M767.2,483.1H746.4a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5h20.8a1.54,1.54,0,0,1,1.5,1.5h0A1.54,1.54,0,0,1,767.2,483.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M686.1,509.2H595.9a4.23,4.23,0,0,1-4.2-4.2V477.6a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2V505A4.23,4.23,0,0,1,686.1,509.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M651.4,483.1H630.6a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5h20.8a1.54,1.54,0,0,1,1.5,1.5h0A1.54,1.54,0,0,1,651.4,483.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.7,431.1H133.5a4.23,4.23,0,0,1-4.2-4.2V399.5a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.1,4.1,0,0,1,223.7,431.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189,404.9H168.2a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5H189a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,189,404.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.7,476.9H133.5a4.23,4.23,0,0,1-4.2-4.2V445.3a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.1,4.1,0,0,1,223.7,476.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189,450.7H168.2a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5H189a1.54,1.54,0,0,1,1.5,1.5h0A1.42,1.42,0,0,1,189,450.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M933.2,361.7h-455a4.65,4.65,0,0,1-4.6-4.6V277.4a4.65,4.65,0,0,1,4.6-4.6h455a4.65,4.65,0,0,1,4.6,4.6v79.7A4.59,4.59,0,0,1,933.2,361.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M933.2,460.6h-455a4.65,4.65,0,0,1-4.6-4.6V376.3a4.65,4.65,0,0,1,4.6-4.6h455a4.65,4.65,0,0,1,4.6,4.6V456A4.53,4.53,0,0,1,933.2,460.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 504.3,
    y: 311.4,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 514.1,
    y: 325.1,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 802.6,
    y: 410.2,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 812.5,
    y: 423.9,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 782.5,
    y: 410.2,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 745.2,
    y: 429.61,
    width: 50.3,
    height: 9.9,
    transform: "translate(124 1038.32) rotate(-72.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 792.4,
    y: 423.9,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 669.1,
    y: 311.4,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 679,
    y: 325.1,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 571.3,
    y: 311.4,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 533.99,
    y: 330.8,
    width: 50.3,
    height: 9.9,
    transform: "translate(70.62 767.85) rotate(-72.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 581.2,
    y: 325.1,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M812.4,318l1.1-14.9a1.65,1.65,0,0,0-1.7-1.8h-8.6a1.71,1.71,0,0,0-1.7,1.8l1.1,14.9s-9,5.8-8.9,10.6c.1,3.7,2.3,21.4,3.3,29.2a4.32,4.32,0,0,0,4.3,3.8h12.4a4.32,4.32,0,0,0,4.3-3.8c1-7.8,3.2-25.5,3.3-29.2C821.4,323.7,812.4,318,812.4,318Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M772.5,318l1.1-14.9a1.65,1.65,0,0,0-1.7-1.8h-8.6a1.71,1.71,0,0,0-1.7,1.8l1.1,14.9s-9,5.8-8.9,10.6c.1,3.7,2.3,21.4,3.3,29.2a4.32,4.32,0,0,0,4.3,3.8h12.4a4.32,4.32,0,0,0,4.3-3.8c1-7.8,3.2-25.5,3.3-29.2C781.5,323.7,772.5,318,772.5,318Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 173.2,
    y1: 555,
    x2: 1129,
    y2: 555
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "261.1 565.2 261.1 685.5 269.2 685.5 271.8 565.2 261.1 565.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "271.8 565.2 261.1 565.2 261.1 578.3 271.5 578.3 271.8 565.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "741.6 565.2 741.6 685.5 733.4 685.5 730.9 565.2 741.6 565.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "730.9 565.2 741.6 565.2 741.6 578.3 731.2 578.3 730.9 565.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "776.2 560.3 226.5 560.3 285 534.7 717.6 534.7 776.2 560.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 226.5,
    y: 560.3,
    width: 549.7,
    height: 7.7
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M291.4,501.4l-12.7,7.3a4,4,0,0,1-5.5-1.5l-36.4-62.8a4,4,0,0,1,1.5-5.5l12.7-7.3a4,4,0,0,1,5.5,1.5l36.4,62.8A4.07,4.07,0,0,1,291.4,501.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M282.5,492.5A4,4,0,1,0,281,498,4.07,4.07,0,0,0,282.5,492.5Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 265.8,
    y1: 482.5,
    x2: 275.1,
    y2: 477.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 263.2,
    y1: 478.1,
    x2: 272.6,
    y2: 472.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M310.6,458.5l-8.2,34.7c-.3,1,4.5,3.5,10.9,5.7s11.8,3.2,12.1,2.3l15.1-32.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M332.7,477.6l5.6,1.9a4.26,4.26,0,0,1,2.4,6l-4.7,9a4.24,4.24,0,0,1-5.2,2l-6.1-2.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M340.5,469c-.4,1.2-7.5-.1-15.7-3s-14.6-6.2-14.2-7.5,7.5.1,15.7,3S340.9,467.7,340.5,469Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.7,288.8,279,319.2a7,7,0,0,1-8.8-6L255.9,189.5a4.74,4.74,0,0,1,5.1-5.3l116.6,8.1a7,7,0,0,1,6.5,6l13,85.2A4.65,4.65,0,0,1,393.7,288.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M399,289.2,283.1,319.9a7.16,7.16,0,0,1-8.9-6.1l-14.4-125a4.89,4.89,0,0,1,5.2-5.4l117.9,8.1a7.13,7.13,0,0,1,6.6,6l13.2,86.1A5.27,5.27,0,0,1,399,289.2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M308.3,207.1l-28.3-.4a1.09,1.09,0,0,1-1.1-1l-.4-3.2a1.16,1.16,0,0,1,1.1-1.3l28.4.8a1.09,1.09,0,0,1,1.1,1l.4,2.9A1.22,1.22,0,0,1,308.3,207.1Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 280.3,
    y1: 217.7,
    x2: 335.1,
    y2: 217
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 281.7,
    y1: 228.8,
    x2: 316.4,
    y2: 227.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.7,297.2l-3.3.7a1.21,1.21,0,0,1-1.5-1.1l-3.3-27.7a1.24,1.24,0,0,1,1.1-1.4l3.3-.5a1.24,1.24,0,0,1,1.4,1.1l3.4,27.5A1.52,1.52,0,0,1,294.7,297.2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M306.4,293.3l-5.5-44a1.24,1.24,0,0,1,1.1-1.4l2.8-.3a1.11,1.11,0,0,1,1.3,1.1l5.5,43.6a1.28,1.28,0,0,1-1,1.4l-2.9.6C307.2,294.5,306.5,294,306.4,293.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M321.7,290l-2.1-16.2a1.25,1.25,0,0,1,1-1.4l2.4-.4a1.24,1.24,0,0,1,1.4,1.1l2.1,16.1a1.28,1.28,0,0,1-1,1.4l-2.4.5A1.19,1.19,0,0,1,321.7,290Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M339.3,287.6l-2.1.4a1.2,1.2,0,0,1-1.5-1l-1.2-8.7a1.25,1.25,0,0,1,1-1.4l2.1-.4a1.19,1.19,0,0,1,1.4,1.1l1.2,8.7A1.13,1.13,0,0,1,339.3,287.6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M380.1,275.5l-8.6-19.3,7.4-17.1c3.4,3.6,5.9,9,6.9,15.1C386.9,262.9,384.6,271.2,380.1,275.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M378.8,239.1l-7.4,17.1-14.5-11.6c2.1-5.9,6.2-10,11.3-10.3C372,234,375.8,235.8,378.8,239.1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M380.1,275.5a11,11,0,0,1-5.4,2.9c-8.4,1.8-17.1-7.2-18.9-20.1a30.88,30.88,0,0,1,1.1-13.8l14.5,11.6Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M477,190.3A229.64,229.64,0,0,0,491.4,214a4.88,4.88,0,0,0,6.9,1.2,119.83,119.83,0,0,1,14.7-8.5,5.45,5.45,0,0,0,2.6-6.9c-2.7-6.3-5.5-14.7-7.8-22.1a16.59,16.59,0,0,0-23.3-9.9h0A16.53,16.53,0,0,0,477,190.3Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M510.2,201.2a4.33,4.33,0,0,1,3.7,1.8,37.67,37.67,0,0,0,7.8,8.5c4.7,3.3,21.8,6.2,23.2,8.7s-2.7,3.3-5.5,3-5.2-.6-5.8.6.2,6.2,4.1,9.7,10.9,7.2,11.2,10.4-7.6.1-11.1-2.1-4.5-2.6-4.5-2.6-.5,1-3.3,2c-1.6.5-3.3-.8-4.8-.5s-8.2,3.7-11.4,2.1c-2.3-1.2-7.4-12.8-9.9-15.9-1.8-2.3-6.1-8.9-8.2-12.2a4.12,4.12,0,0,1-.1-4.4A16.75,16.75,0,0,1,510.2,201.2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M533.2,239.3a29.25,29.25,0,0,1-5.5-3.6,11,11,0,0,1-1.6-2.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M525.1,240.7a20.78,20.78,0,0,1-3.3-1.7,17.84,17.84,0,0,1-2.2-2.9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M519.3,242.7a11.08,11.08,0,0,1-2.8-1.6,24.58,24.58,0,0,1-2.1-2.4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M444,269.4a.83.83,0,0,1,1.6,0,11.22,11.22,0,0,0,1.8,3.8,12.25,12.25,0,0,0,3.8,1.8.83.83,0,0,1,0,1.6,11.22,11.22,0,0,0-3.8,1.8,12.25,12.25,0,0,0-1.8,3.8.83.83,0,0,1-1.6,0,11.22,11.22,0,0,0-1.8-3.8,12.25,12.25,0,0,0-3.8-1.8.83.83,0,0,1,0-1.6,6.25,6.25,0,0,0,5.6-5.6Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M456.1,211.7a.63.63,0,0,1,1.2,0,7.51,7.51,0,0,0,1.3,2.7,8.48,8.48,0,0,0,2.7,1.3.62.62,0,0,1,0,1.2,7.51,7.51,0,0,0-2.7,1.3,8.48,8.48,0,0,0-1.3,2.7.63.63,0,0,1-1.2,0,7.51,7.51,0,0,0-1.3-2.7,8.48,8.48,0,0,0-2.7-1.3.62.62,0,0,1,0-1.2,4.54,4.54,0,0,0,4-4Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M550.8,261.4a.62.62,0,0,1,1.2,0,7.51,7.51,0,0,0,1.3,2.7,11.34,11.34,0,0,0,2.7,1.3.63.63,0,0,1,0,1.2,7.51,7.51,0,0,0-2.7,1.3,8.48,8.48,0,0,0-1.3,2.7.63.63,0,0,1-1.2,0,7.51,7.51,0,0,0-1.3-2.7,8.48,8.48,0,0,0-2.7-1.3.63.63,0,0,1,0-1.2,7.51,7.51,0,0,0,2.7-1.3A6.17,6.17,0,0,0,550.8,261.4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M466.2,244.3c.2-.5.8-.5.9,0a9.26,9.26,0,0,0,1,2.2,5,5,0,0,0,2.2,1c.5.2.5.8,0,.9a9.26,9.26,0,0,0-2.2,1,5,5,0,0,0-1,2.2c-.2.5-.8.5-.9,0a9.26,9.26,0,0,0-1-2.2,5,5,0,0,0-2.2-1c-.5-.2-.5-.8,0-.9a9.26,9.26,0,0,0,2.2-1A7.66,7.66,0,0,0,466.2,244.3Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M558.8,288.1a.83.83,0,0,1,1.6,0,11.22,11.22,0,0,0,1.8,3.8,12.25,12.25,0,0,0,3.8,1.8.83.83,0,0,1,0,1.6,11.22,11.22,0,0,0-3.8,1.8,12.25,12.25,0,0,0-1.8,3.8.83.83,0,0,1-1.6,0,11.22,11.22,0,0,0-1.8-3.8,12.25,12.25,0,0,0-3.8-1.8.83.83,0,0,1,0-1.6,11.22,11.22,0,0,0,3.8-1.8A13.5,13.5,0,0,0,558.8,288.1Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M727.8,268.2s-1.4,1.4,1.2,12a59.48,59.48,0,0,0,8.5,18.7,18.42,18.42,0,0,0,5.3-17.4C740.6,270.5,727.8,268.2,727.8,268.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M729.3,299.4s-2,.6-6.7,5.5S711,312.3,702.8,316s-12.2-13.5-10.1-22.2,11-14.7,11-14.7l17.5,2.4s5.8-6.9,8.1-2.4S731.3,293.7,729.3,299.4Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M714.3,331.3,654.7,345a4.82,4.82,0,0,1-5.8-3.6L632,268.2a4.82,4.82,0,0,1,3.6-5.8l59.6-13.7a4.82,4.82,0,0,1,5.8,3.6l16.8,73.2A4.69,4.69,0,0,1,714.3,331.3Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M689.2,269.7l-38.8,8.9a2.31,2.31,0,0,1-2.8-1.8h0a2.31,2.31,0,0,1,1.8-2.8l38.8-8.9a2.31,2.31,0,0,1,2.8,1.8h0A2.53,2.53,0,0,1,689.2,269.7Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 650.3,
    y1: 288.9,
    x2: 693.7,
    y2: 278.9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 652,
    y1: 296.2,
    x2: 695.4,
    y2: 286.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M677.9,325l-16,3.7a2.31,2.31,0,0,1-2.8-1.8l-3.7-16a2.31,2.31,0,0,1,1.8-2.8l16-3.7a2.31,2.31,0,0,1,2.8,1.8l3.7,16A2.53,2.53,0,0,1,677.9,325Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 681.9,
    y1: 302.3,
    x2: 698.2,
    y2: 298.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 683.7,
    y1: 310.2,
    x2: 700.1,
    y2: 306.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 685.5,
    y1: 318.2,
    x2: 695.4,
    y2: 315.9
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M676.6,255.3l-21.2,4.9a2.11,2.11,0,0,1-2.5-2.5l.2-1a2.17,2.17,0,0,1,1.6-1.6l20.3-4.7a2.07,2.07,0,0,1,2.1.7l.6.8A2.09,2.09,0,0,1,676.6,255.3Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M722.6,275.4s-2.5,1.3-7.3,0-5.6-2.5-10.6-3.8-11.9.1-13.1,2.2,2,3.4,6.3,3.9,6.3,8.7,13.2,11.8C722.6,294.6,732.8,279,722.6,275.4Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M691.6,273.8c-1.2,2.1,2,3.4,6.3,3.9s6.3,8.7,13.2,11.8a11,11,0,0,0,6.8.8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M730.2,270.8s-5.3,3.4-7.6,4.6a26.6,26.6,0,0,1,6.3,12.3c1.8,7.9.4,11.7.4,11.7s5.9-.6,8.8-2.7c0,0,2.8-4.6.5-13.6S730.2,270.8,730.2,270.8Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M793,258.6a20.15,20.15,0,0,0-30.9-10.7,222.29,222.29,0,0,1-19,12.1l-15.3,8.3s8.7,8.6,10,18.1-.3,12.6-.3,12.6,23.9-5.9,45-16.2A20.5,20.5,0,0,0,793,258.6Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M735.5,291.7a1.2,1.2,0,1,0-1.2,1.2A1.16,1.16,0,0,0,735.5,291.7Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "601.3 476.3 672 468 670.8 480.8 656.9 482.8 655.5 485.4 601.3 476.3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M655.5,484l18.4-72.9a6.41,6.41,0,0,1,5.3-4.8l94.5-14.1a2.82,2.82,0,0,1,3.1,3.6l-19.3,65.3a6.62,6.62,0,0,1-4.8,4.5l-93.9,21.9A2.84,2.84,0,0,1,655.5,484Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M727.8,437.4c-1,3.6-4.3,7.1-7.6,7.8s-5.1-1.7-4.1-5.3,4.3-7.1,7.6-7.8S728.8,433.8,727.8,437.4Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M656.9,487.2c-.3-.2-41.3-5.6-52.7-7.2a3.26,3.26,0,0,1-2.9-3.3v-.4l55.6,6.5v4.4Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M742.9,349.8h30.8a2.53,2.53,0,0,1,2.5,2.7l-1.6,19.3a3.43,3.43,0,0,1-3.1,3.2l-31,3.4a2.44,2.44,0,0,1-2.7-2.6l1.7-22.7A3.35,3.35,0,0,1,742.9,349.8Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M740.9,350.5l18,9.7a3.54,3.54,0,0,0,3.7-.3l12.8-9.4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M569.8,252.5l-3.2,3.5a1.52,1.52,0,0,0,0,2h0a1.53,1.53,0,0,0,1.8.3l3.8-2.3Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M599,261l.9,4.7a1.55,1.55,0,0,1-1,1.7h0a1.38,1.38,0,0,1-1.7-.8l-2-4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 588.3,
    cy: 243.3,
    r: 21.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 588.28,
    cy: 243.32,
    r: 14,
    transform: "translate(-44.46 313.48) rotate(-28.8)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "592.2 248.3 588.3 243.3 590.4 236.3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M574.4,222.2a1.16,1.16,0,0,1-1.5-.8,6.34,6.34,0,0,1,11.6-4.4,1.07,1.07,0,0,1-.6,1.6Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M611.3,233a1.15,1.15,0,0,0,1.7.1,6.31,6.31,0,0,0-7.4-9.9,1.08,1.08,0,0,0-.4,1.6Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M598.2,219.9l-5.7-1.6a1.77,1.77,0,0,1-1.2-2.2h0a1.77,1.77,0,0,1,2.2-1.2l5.7,1.6a1.77,1.77,0,0,1,1.2,2.2h0A1.81,1.81,0,0,1,598.2,219.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 592.03,
    y: 218.57,
    width: 5.6,
    height: 4.3,
    transform: "translate(216.91 730.35) rotate(-73.8)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M355.6,388.7l.9,9.2a2.16,2.16,0,0,1-1.3,2.2,7.22,7.22,0,0,0-4.2,7.2l1.1,10.2a7,7,0,0,0,5.6,6.2,2.24,2.24,0,0,1,1.7,1.9l.9,9.2a2.11,2.11,0,0,1-3.1,2.1l-2.2-1.1a15.78,15.78,0,0,1-8.6-12.6l-2.1-20.3a16,16,0,0,1,5.9-14.1l2-1.6A2.14,2.14,0,0,1,355.6,388.7Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M402.3,194.4c1.8,12.2-5,23.3-16.4,24.9-13.1,1.8-26.8-9.5-28.6-25.1-1.7-15.3,9-25.8,22.1-24C390.9,171.8,400.6,182.4,402.3,194.4Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M407,192.3c1.8,12.6-5.1,24.1-16.9,25.7-13.6,1.9-27.7-9.8-29.5-25.9-1.8-15.8,9.3-26.6,22.8-24.8C395.2,169,405.2,180,407,192.3Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M390.6,185.3c.4,3.1-1.5,5.5-4.3,5.5s-5.7-2.7-6.1-5.9,1.7-5.6,4.6-5.4A6.79,6.79,0,0,1,390.6,185.3Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M393.3,204.9l-10.3.7c-2.5.2-4.8-1.9-5.2-4.7h0c-.8-6.1,3.2-10.9,8.5-10.8h0c5,.1,9.5,4.6,10.3,10h0C396.8,202.7,395.4,204.8,393.3,204.9Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M714.8,372.6a4,4,0,1,0-.3,5.6A3.88,3.88,0,0,0,714.8,372.6Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M709.6,363.5l-.7-.8a6.28,6.28,0,0,0-8.8-.4h0a6.28,6.28,0,0,0-.4,8.8l.7.8a7.26,7.26,0,0,1,1.7,3.1c.2.9.5,1.9.7,2.9a2.91,2.91,0,0,0,4.8,1.4l4.4-4,4.4-4a2.92,2.92,0,0,0-1-4.9c-1-.3-1.9-.7-2.8-1A6.72,6.72,0,0,1,709.6,363.5Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M630.2,379.2a74,74,0,0,1,0,25.2l32.4-7s-7.2-12-9.1-23Z"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 630.9,
    y1: 384.4,
    x2: 654.7,
    y2: 379.4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 636.5,
    y1: 389.1,
    x2: 651.9,
    y2: 385.4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 636.8,
    y1: 393.9,
    x2: 647.1,
    y2: 391.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M706.8,489.2l21.8-4.9s.3,10,15.7,15.9c0,0-17.1,13-22.4,16.4C722,516.5,709.2,509.9,706.8,489.2Z"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 708.1,
    y1: 495.8,
    x2: 730,
    y2: 488.7
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 715.3,
    y1: 499.9,
    x2: 729,
    y2: 493.6
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 717.6,
    y1: 504.1,
    x2: 731.3,
    y2: 496.7
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 720.6,
    y1: 508.1,
    x2: 728.5,
    y2: 503.3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M361,333.3a16.55,16.55,0,0,1-5.7.2l1.8-2.8c-3.9.1-13.3-5-14.3-9.7a2.79,2.79,0,0,1,.1-1.6h0v-.1c1.5-3,9.4-2.3,15.2,3.4C365,329.4,361,333.3,361,333.3Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M357.2,330.7l-1.8,2.8a22.15,22.15,0,0,1-8-2.7,14.25,14.25,0,0,1-6.5-6.9c1.1-2.5,1.9-4.2,2.1-4.6a2.86,2.86,0,0,0-.1,1.6C343.9,325.7,353.3,330.8,357.2,330.7Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M301.6,361s4.6,2.1,8.9,1.5,12.7-3,14.4-2.1,4.6,1,3.7,3.9-2.6,6.3-6.4,6.5-7.6,3.2-13.9,1.4-10-2.7-10.2-5.2S301.6,361,301.6,361Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M361,333.3c-1.6,4.7-22.5,32.2-32.4,46.6s-26.7,55.2-35.1,53.5-18.8-9.9-17-14.6,23.1-18.1,39.3-41.2,15.8-39.1,20.7-52.2c2.1-5.6,3.6-5.2,3.6-5.2a10.35,10.35,0,0,0,.7,3.8,13.35,13.35,0,0,0,6.5,6.9,22.15,22.15,0,0,0,8,2.7A14.9,14.9,0,0,0,361,333.3Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325,374.7s4-7.4,5-11.9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M328.8,375.7s2.7-5.1,4.1-6.4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.1,395.1a64.33,64.33,0,0,1-4,8.5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M308.5,393.7a52.36,52.36,0,0,1-10.4,11.2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M317,367.2a80.36,80.36,0,0,0,9.7,5.4c3.6,1.4,8.2-.1,8.6-.1s2.3,3,.6,5.1-3.6,2.4-3.8,3.1.3,4.7-.8,6.1-3.2,2.2-3.9,3.1-1.4,5.4-2.5,6.1-2.5,3-5.3,3.4-13.8-4-24-11.9a56.21,56.21,0,0,0-10.7-6.8s4.5-19.7,12.7-17.9S317,367.2,317,367.2Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M317,367.2a80.36,80.36,0,0,0,9.7,5.4c3.6,1.4,8.2-.1,8.6-.1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M292.3,354.4a1.92,1.92,0,0,1,2.4.1c1.3,1,6.2,4.9,6.8,6.5s-2.7,11.5-8,17.6-8.1,6.1-8.4,6-7.7-3.5-8.7-4.8a3.26,3.26,0,0,1-.6-2.7S289.9,354.3,292.3,354.4Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M227.6,319.8a20.45,20.45,0,0,0,1.9,27.9c2.3,2.1,4.9,4.5,7.8,7.1,15.6,14,39.8,22.7,39.8,22.7,13.2-6.1,15.2-23.1,15.2-23.1-11.9-7.5-23.7-21.5-32.4-33.7a20.44,20.44,0,0,0-32.3-.9Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M332.2,380.8a18.67,18.67,0,0,1-4.4,1.5,25.35,25.35,0,0,1-4.1,0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M328,389.6a6.85,6.85,0,0,1-2.9,1.3,5.57,5.57,0,0,1-3.1-.6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M324.1,396.9s-2.4.8-3.7-.4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M592.6,496c-19.1.4-49.1,7.6-67.3,15a312.15,312.15,0,0,0-30.5,14.3s4.3-2.4,9.4,7.4,3.3,21.2,3.3,21.2c2.6-.7,64.6-2.6,84.4-5.2s42.7-9.8,41.3-29.1-18.4-24.6-41.7-28.9-36.3-2.5-37.7-2.9a18.49,18.49,0,0,1-8.3-5.1c-2.4-2.9-4.9-10.8-4.9-10.8s-60.4-3.8-66.5,6.4,21.3,39.4,21.3,39.4Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M448.6,470.7s-3.3,7.2-4.5,9.8-28.9,3.6-41.3,3.8-36.7,5.2-38.6,23.1c-2.2,20.4,14.9,29.9,45.4,32.1,34.3,2.5,66.1,1.7,72.8,2.4s25.2-7.6,27.3-15.3S540.9,513,540.9,513s6.4-32-4.1-38.4S448.6,470.7,448.6,470.7Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M509.7,519.4s-56.8-32.7-101.9-30.8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M494.8,525.4s-2.8,1.2-1.2,10.8S504,556,507.5,554s1.7-19.4-2.3-25.2S494.8,525.4,494.8,525.4Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M488.3,528.6s-5.5,6.7-8,8.6-13.7,2.7-17.8,9.1,5.3,21.1,12.9,18.7c-2.1,1.3-3.9,2.5-5.3,3.4-6.8,4.6-19.2,11.5-28,1.4-7.4-8.6-4.8-19,.6-25.9s19.3-7.7,22.5-8.6,10.5-6.2,13.7-8.1C481.6,525.6,483.6,527.7,488.3,528.6Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M507.7,550.7c-.4.1-7.6,1.3-10.6,1.9-2.4.5-13.8,7.2-21.8,12.3-7.6,2.4-17-12.3-12.9-18.7s15.3-7.2,17.8-9.1,8-8.6,8-8.6l2.3.3c6.4.5,9.7-1.7,9.7-1.7a19.08,19.08,0,0,1,3.8,5.5C507.6,539.3,507.9,546.6,507.7,550.7Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M592.6,496c-19.1.4-49.1,7.6-67.3,15a312.15,312.15,0,0,0-30.5,14.3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M368.3,497.4a7.16,7.16,0,0,1,5.5-.1c5.4,1.8,7.2,13.7,4.5,21.1s-8.7,7.1-10.7,5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M629.7,508.1s-5-5.7-10.9,1.4c-6.5,7.7-3.1,20.7,2.1,23.8s8.2,0,8.2,0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M411.4,367a1.1,1.1,0,1,1-1.1-1.1A1.11,1.11,0,0,1,411.4,367Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M433.2,348.3c-2.1,7-4.3,10-4.1,16.4a22.61,22.61,0,0,1-21.1-4.2c.6-2.7.9-4.8.5-6.1-1.2-4.8-7.7-7-12.2-13s-4.9-16.6-2.7-17.9c1-.6,2-.4,3.5,4.6a29.61,29.61,0,0,0,2.5,5.9c-2.1-4.8-3-20.6,2.8-18.2,1.9.8-.3,4.2,2,10.3a15.39,15.39,0,0,0,6,8,12.89,12.89,0,0,1,1.9-8.4c2.2-3.1,7.8-6.6,8.8-3.3s-4,4.4-4.4,8.5c-.6,4.9,4.9,8.7,8.6,5.5s1.6-6.8,0-9.1-4.1-5.1-2.3-6.4,6.3.2,9.5,5.7S435.3,341.3,433.2,348.3Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M453.5,420s-22.5,28.4-37.3,34.8-24.8,1.9-27.7-13.6,6.3-43.2,10.3-53.4c2.9-7.6,7.5-19.6,9.2-27.2a23,23,0,0,0,21.1,4.2c.1,6.1-2.7,28.6-3,30.7.1-.7,1.3-4,9.7-15.8,9.7-13.5,19.4-19.4,19.4-19.4s8.2,3.9,10.6,22.2S453.5,420,453.5,420Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M426.1,395.5s-.9,25.6-4.2,33.9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M410.3,334.2a11.53,11.53,0,0,0,1.6,4.4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M405.7,368.5s5.7,8.2,22.8,5.8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M391.4,449.9s-2.6-8.9,7-11,21.3,11.8,13.9,17.3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M399.5,334.2a18,18,0,0,0,3.5,4.9c1,1,2.4,2,3,3.3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M518.9,273.7c11.4,2.9,16.8,9.4,16.3,25.8s-2.7,22.3,5.1,31.4,9.9,21.9-4.9,30-47.2,10.2-63.3,0-18-21.1-13.2-31.8,17.6-17.7,14.8-25.4.6.7.6.7a21.64,21.64,0,0,1-7.7-18.3c.6-12.2,15.6-16.8,23.4-17.2,4-.2,8.3,2.3,14.2,3.3C510.1,273,516,273,518.9,273.7Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M495,351.5s-21.6,1.2-34.2,5.7-10.3,14.5-11.9,25-11.9,21.2-6.7,35.5,10.3,22.4,7.6,33.4-5.2,16.5-4.8,19.6,14.8,12.6,20.3,14.5,16.2-5.7,16.2-5.7,5.5,7.2,13.5,8.8,40.4-6.7,47.8-15a51.86,51.86,0,0,1-5-20.5c-.2-11.2,6.3-25.1,8.7-32.8s15.9-37.4,10.6-47.3C553.3,365.6,524.9,349.6,495,351.5Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M440.6,482.6l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,440.6,482.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M442.7,464.5l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,442.7,464.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M444.9,446.5l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.87,1.87,0,0,1,444.9,446.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M447,428.4l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,447,428.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M449.1,410.3l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,449.1,410.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M456.9,484.5l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,456.9,484.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M459,466.4l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,459,466.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M461.1,448.4l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.93,1.93,0,0,1,461.1,448.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M463.3,430.3l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,463.3,430.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M465.4,412.2l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,465.4,412.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M473.2,486.4l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,473.2,486.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M475.3,468.3l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,475.3,468.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M477.4,450.3l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,477.4,450.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M479.5,432.2l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,479.5,432.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M481.6,414.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,481.6,414.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M489.4,488.3l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,489.4,488.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M491.6,470.3l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.87,1.87,0,0,1,491.6,470.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M493.7,452.2l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,493.7,452.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M495.8,434.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,495.8,434.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M497.9,416.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.87,1.87,0,0,1,497.9,416.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M505.7,490.2l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,505.7,490.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M507.8,472.2l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.87,1.87,0,0,1,507.8,472.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M509.9,454.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.93,1.93,0,0,1,509.9,454.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M512.1,436l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,512.1,436Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M514.2,418l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,514.2,418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M522,492.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,522,492.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M524.1,474.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,524.1,474.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M526.2,456l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,526.2,456Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M528.3,437.9l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,528.3,437.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M530.4,419.9l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.93,1.93,0,0,1,530.4,419.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M538.2,494l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,538.2,494Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M540.4,476l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,540.4,476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M542.5,457.9l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,542.5,457.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M544.6,439.8l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,544.6,439.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M546.7,421.8l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,546.7,421.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M451.2,392.3l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.87,1.87,0,0,1,451.2,392.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M453.3,374.2l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.93,1.93,0,0,1,453.3,374.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M455.5,356.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,455.5,356.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M457.6,338.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,457.6,338.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M467.5,394.2l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,467.5,394.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M469.6,376.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,469.6,376.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M471.7,358l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,471.7,358Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M473.9,340l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,473.9,340Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M483.8,396.1l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,483.8,396.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M485.9,378l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,485.9,378Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M488,359.9l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,488,359.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M490.1,341.9l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,490.1,341.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M500,398l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,500,398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M502.2,379.9l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,502.2,379.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M504.3,361.9l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.87,1.87,0,0,1,504.3,361.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M506.4,343.8l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,506.4,343.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M516.3,399.9l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,516.3,399.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M518.4,381.8l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,518.4,381.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M520.5,363.8l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.93,1.93,0,0,1,520.5,363.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M522.7,345.7l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,522.7,345.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M532.6,401.8l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,532.6,401.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M534.7,383.7l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,534.7,383.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M536.8,365.7l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,536.8,365.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M538.9,347.6l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.94,1.94,0,0,1,538.9,347.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M548.8,403.7l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.93,1.93,0,0,1,548.8,403.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M551,385.7l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A1.87,1.87,0,0,1,551,385.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M553.1,367.6l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,553.1,367.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M555.2,349.5l1,1.2a2,2,0,0,1-.3,2.8l-1.2,1a2,2,0,0,1-2.8-.3l-1-1.2a2,2,0,0,1,.3-2.8l1.2-1A2,2,0,0,1,555.2,349.5Z"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M557.5,373.8a108.67,108.67,0,0,1,18.4,27s.5-34.6,1.2-37a39.27,39.27,0,0,0,21.5-1.7s2.9,26.7,7.2,47,9.1,50.6-5.5,54.6-27.9-5.2-45.6-28.9-16.2-35.5-16.2-41.5C538.4,386.2,548,368,557.5,373.8Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M575.9,400.9s-.7,21.5,1.9,35.1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M576.5,373.2s12.8,4,23-2.5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M595.6,368.1a1.1,1.1,0,1,1-1.1-1.1A1,1,0,0,1,595.6,368.1Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M597.8,362.5s-1-7.1,3.8-9.4,9.2-1.2,14.1-4.8,13.2-15,12.9-17.5-2.1-1.4-5.4,1.3a19.69,19.69,0,0,1-4.8,3.3s2-6.8,1.1-11.8-4.3-5.6-5.1-5.1,0,2.6-.2,6.6-1.4,7.3-4.9,9.8a12.5,12.5,0,0,0-.7-7c-1.6-3.8-4.3-6.3-6.4-5.7s-1.4,2.2-.4,4.4,2.6,6.2-1.6,10.4a5.24,5.24,0,0,1-8.7-5.6c2.3-5.6,5.8-6.9,7.6-8.4s1.3-4.2-2.5-3.6-10.3,5.2-14.1,10.3-4.9,12-5,18.8-.4,15.5-.4,15.5,2.5,3.1,8,3.1S597.8,365,597.8,362.5Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M618.4,335.5a50.93,50.93,0,0,1-4.1,8.5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M609.2,334.9a17.51,17.51,0,0,1-3.2,7.8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M585.6,463.3s-2.5-4,3.6-10.1,19.1-5.4,19.5.9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M488.5,350.1s-5.6-.3-9.1,7.3-2.5,23.2,1.3,25.6,14-7.9,14-7.9,8.6,11.6,14.8,11.1,14-11.6,13.5-23.8-5.5-13.6-8.2-13.9C512.2,348,488.5,350.1,488.5,350.1Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M494.7,375s-19.7,21.8-19.9,25.9,6.5,5.4,8.3,4.5S496.7,374.7,494.7,375Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M494.5,377.7s3.4,24.2,5.6,28,9.2-1.9,8.4-5.2-10.3-22.6-13.8-25.4S494.5,377.7,494.5,377.7Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M518.9,328.8s-2.2,13.7-.6,24c0,0-9.5,21.1-23.5,21.1-6.9,0-9.1-14.2-7.9-19.8l2.1-15.6S503,314.3,518.9,328.8Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M507.4,343.3c-6,3.6-12.6,5.4-19.6,4l-.8,5.9C494.6,351.7,502.3,349.5,507.4,343.3Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M475.3,299.3a136.91,136.91,0,0,1-.8,20.5c-1.3,12.7-.8,21,10,26.4s28.3.5,34.7-14.9,14.9-44.7-8.1-49.1S475,283.3,475.3,299.3Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M491.3,289.2s4.4,14.8,14.2,18.6,8.3,13,13.2,11.9,8.7-5.1,12-1.2,3.6-30.4-13.3-36.3-34.8-6.2-40.1-.8-3.4,22.7-3.4,22.7S484.7,301.6,491.3,289.2Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M519.8,319.8s2.3-5.7,7.2-4.7,4.5,16.5-8,15.7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M484.8,314.5a6.06,6.06,0,0,1,.2,4.2,7.22,7.22,0,0,1-.9,2l-.6.9c-.1.2-.3.5-.4.7a3.1,3.1,0,0,0,.4,2.9,5.5,5.5,0,0,0,3,2.1,3,3,0,0,1-2.1,0,4.53,4.53,0,0,1-1.9-1.1,4.64,4.64,0,0,1-1.3-2,4.3,4.3,0,0,1,.2-2.5,8.79,8.79,0,0,1,.6-1c.2-.3.4-.5.6-.8a8.64,8.64,0,0,0,1-1.6A10,10,0,0,0,484.8,314.5Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M492.2,334a7.23,7.23,0,0,0,8-3.7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M498.6,314.5s.4,2.2,4.2,2.6a4.84,4.84,0,0,0,4.7-2.2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M483,312.9s-3,2.4-5.4-.6"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M485.8,303.4c.2-1.3-1.3-3.5-3.3-4.1s-5.2,2.2-4.9,3.4,2.3-.6,4.1-.4C483.3,302.5,485.6,304.5,485.8,303.4Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M509.7,305.6c.2-1.3-1.3-3.5-3.3-4.1s-5.2,2.2-4.9,3.4,2.3-.6,4.1-.4S509.6,306.7,509.7,305.6Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M526.6,319.8a3.4,3.4,0,0,0-2.1,1.4,3,3,0,0,0-.2,1v1.4a4.67,4.67,0,0,1-.3,1.7,2.26,2.26,0,0,1-1.3,1.4,3.8,3.8,0,0,1-3.3-.3,6.5,6.5,0,0,0,2.5-1,2.42,2.42,0,0,0,.6-2v-1.6a2.72,2.72,0,0,1,.8-1.7A3.59,3.59,0,0,1,526.6,319.8Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 476,
    cy: 313,
    rx: 8.9,
    ry: 9.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 501.68,
    cy: 315.77,
    r: 10.3
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M484.9,313.8s1.6-1.7,6.6.4"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 512,
    y1: 315.8,
    x2: 521.8,
    y2: 316.7
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M524.2,328.4l-3.4,5.9a1.14,1.14,0,0,0,1,1.7h6.8a1.14,1.14,0,0,0,1-1.7l-3.4-5.9A1.21,1.21,0,0,0,524.2,328.4Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M663.5,528.5l2.4,22.2c0,1.6,8.3,2.8,18.5,2.8s18.5-1.3,18.5-2.8l2.4-22.2Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M705.3,528.5c0,1.8-9.4,3.2-20.9,3.2s-20.9-1.4-20.9-3.2,9.4-3.2,20.9-3.2S705.3,526.8,705.3,528.5Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M678.8,528.5s-11.2-4.4-10-13,9.5,9.2,11.6,6.5-.6-15.8,4-17,3.4,17.2,3.4,17.2a27.29,27.29,0,0,0,7.6-5.7c2.9-3.4,7.1,4.2-4.8,12A15.48,15.48,0,0,1,678.8,528.5Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M777.5,522.7a5.4,5.4,0,1,1-5.4-5.4A5.51,5.51,0,0,1,777.5,522.7Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M392.6,542a19.38,19.38,0,0,0-8,4.2,26.9,26.9,0,0,1-18.5,5.9,25.93,25.93,0,0,1-20-10.9A280.11,280.11,0,0,0,392.6,542Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M366,552.2c-17.6.3-42.2,0-49.8-.1-8.8.7-18.7-2.7-25.3-13.6,0,0,6.5,1,23.2,1.1s30-1.1,30-1.1c.6,1,1.2,1.9,1.8,2.8A26.88,26.88,0,0,0,366,552.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/subscribe.bfdb90e756e135e7ba5082d13b502907.svg";
export { ForwardRef as ReactComponent };